import React from 'react';
import Header from '../Header/Header';
import { Row, Col, Card, Container, Button } from 'react-bootstrap';
import howMuchJs from '../../images/how-much-js.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookOpen } from '@fortawesome/free-solid-svg-icons';

const Blogs = () => {
    return (
        <div className="text-white" style={{ backgroundColor: '#141c3a', height: "100vh" }}>
            <Header></Header>
            <div className="text-dark">
                <Container className="py-5">
                    <Row xs={1} md={3} className="g-4">
                        <Col>
                            <Card className="d-flex">
                                <Card.Img width="100%" height="350px" variant="top" src={howMuchJs} />
                                <Card.Body className="text-start">
                                    <Card.Title>How much JavaScript should I learn? 🤔</Card.Title>
                                    <Card.Text>
                                        When it comes to studying JavaScript, people become bewildered, especially those who are new to programming. Beginners frequently believe that they will master all of JavaScript before moving on to frameworks like React, Angular, and Vue, but this is not the case.
                                    </Card.Text>

                                    <a target="_blank" rel="noreferrer" href="https://medium.com/@shadmansaalim321/how-much-javascript-should-you-learn-8c9178ef6f5">
                                        <Button variant="outline-success">

                                            Read More <FontAwesomeIcon icon={faBookOpen} />
                                        </Button>
                                    </a>

                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default Blogs;